module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [(_vm.conf.isGroup) ? _c('div', {
    staticClass: "group",
    class: {
      dimmed: !_vm.nContexts
    },
    on: {
      "click": _vm.toggleContent
    }
  }, [_c('span', {
    staticClass: "line icon"
  }, [_c('icon', {
    staticClass: "open-button",
    attrs: {
      "name": _vm.open ? 'minus-square-o' : 'plus-square-o'
    }
  }), _vm._v(" "), _c('span', {
    class: {
      handle: _vm.editing
    }
  }, [_vm._v(_vm._s(_vm.isRoot ? _vm.$t("layerSelector.layers") : _vm.label))])], 1), _vm._v(" "), (_vm.conf.infoFile) ? _c('span', {
    staticClass: "info-link icon",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.showInfo($event)
      }
    }
  }, [_c('icon', {
    attrs: {
      "name": "info-circle"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "counter"
  }, [_vm._v(_vm._s(_vm.nActive ? '‎[' + _vm.locNActive + '‎]' : null))]), _vm._v(" "), (_vm.editing && !_vm.isRoot) ? [_c('span', {
    staticClass: "icon",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.editItem($event)
      }
    }
  }, [_c('icon', {
    staticClass: "icon edit",
    attrs: {
      "name": "pencil-square-o"
    }
  })], 1), _vm._v(" "), _c('span', {
    staticClass: "icon",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.deleteItem($event)
      }
    }
  }, [_c('icon', {
    staticClass: "icon edit",
    attrs: {
      "name": "trash-o"
    }
  })], 1)] : _vm._e()], 2) : _c('div', [(_vm.hasLayers) ? _c('span', {
    staticClass: "icon",
    on: {
      "click": _vm.toggleContent
    }
  }, [(_vm.open) ? _c('icon', {
    staticClass: "open-button",
    attrs: {
      "name": "caret-down"
    }
  }) : _c('icon', {
    staticClass: "open-button",
    attrs: {
      "name": "caret-right"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.hasLayers) ? _c('span', {
    staticClass: "icon",
    on: {
      "click": _vm.toggleActive
    }
  }, [(_vm.conf.parent.exclusive) ? [(_vm.active) ? _c('icon', {
    staticClass: "activate-button",
    class: {
      highlighted: _vm.highlighted, active: _vm.active
    },
    attrs: {
      "name": "dot-circle-o"
    }
  }) : _c('icon', {
    staticClass: "activate-button",
    class: {
      highlighted: _vm.highlighted, active: _vm.active
    },
    attrs: {
      "name": "circle"
    }
  })] : [(_vm.active) ? _c('icon', {
    staticClass: "activate-button",
    class: {
      highlighted: _vm.highlighted, active: _vm.active
    },
    attrs: {
      "name": "check-square"
    }
  }) : _c('icon', {
    staticClass: "activate-button",
    class: {
      highlighted: _vm.highlighted, active: _vm.active
    },
    attrs: {
      "name": "square"
    }
  })]], 2) : _vm._e(), _vm._v(" "), (_vm.conf.hasLegends) ? _c('span', {
    staticClass: "icon",
    staticStyle: {
      "padding-left": "2px",
      "padding-right": "2px"
    },
    on: {
      "click": _vm.toggleLegend
    }
  }, [_c('icon', {
    staticClass: "legend-link",
    class: {
      active: _vm.active
    },
    attrs: {
      "name": "th-list"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.conf.inlineLegendUrl) ? _c('img', {
    staticClass: "inline-legend",
    attrs: {
      "src": _vm.conf.inlineLegendUrl
    }
  }) : _vm._e(), _vm._v(" "), _c('span', {
    class: {
      dimmed: !_vm.hasLayers, handle: _vm.editing
    },
    on: {
      "mouseover": function($event) {
        return _vm.highlightContext(true)
      },
      "mouseout": function($event) {
        return _vm.highlightContext(false)
      },
      "click": _vm.toggleActive
    }
  }, [_vm._v(_vm._s(_vm.label))]), _vm._v(" "), (_vm.conf.infoFile) ? _c('span', {
    staticClass: "info-link icon",
    on: {
      "click": _vm.showInfo
    }
  }, [_c('icon', {
    attrs: {
      "name": "info-circle"
    }
  })], 1) : _vm._e(), _vm._v(" "), (this.conf.times && !!this.conf.times.length) ? _c('span', {
    staticClass: "times-button icon",
    class: {
      active: _vm.showTimeMenu
    },
    on: {
      "click": _vm.toggleTimeMenu
    }
  }, [_c('icon', {
    attrs: {
      "name": "clock-o"
    }
  }), _vm._v(" " + _vm._s(_vm.selectedTime.humanReadable) + "\n    ")], 1) : _vm._e(), _vm._v(" "), (_vm.hasStatistics) ? _c('span', {
    staticClass: "icon statistics",
    attrs: {
      "title": _vm.$t('item.statisticsAvailable')
    }
  }, [_c('icon', {
    attrs: {
      "name": "bar-chart"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.hasDataDownload) ? _c('span', {
    staticClass: "icon datadownload info-link",
    attrs: {
      "title": _vm.$t('item.downloadAvailable')
    },
    on: {
      "click": _vm.showDownloads
    }
  }, [_c('icon', {
    attrs: {
      "name": "download"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.showTimeMenu) ? _c('time-select', {
    attrs: {
      "times": _vm.conf.times,
      "selectedTime": _vm.selectedTime
    },
    on: {
      "setTime": _vm.setTime
    }
  }) : _vm._e(), _vm._v(" "), (_vm.editing) ? [_c('span', {
    staticClass: "icon",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.editItem($event)
      }
    }
  }, [_c('icon', {
    staticClass: "icon edit",
    attrs: {
      "name": "pencil-square-o"
    }
  })], 1), _vm._v(" "), _c('span', {
    staticClass: "icon",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.deleteItem($event)
      }
    }
  }, [_c('icon', {
    staticClass: "icon edit",
    attrs: {
      "name": "trash-o"
    }
  })], 1)] : _vm._e(), _vm._v(" "), (_vm.open) ? _c('div', {
    staticStyle: {
      "padding-left": "21px"
    }
  }, [_c('icon', {
    attrs: {
      "name": "adjust"
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.opacity),
      expression: "opacity"
    }],
    staticClass: "slider",
    attrs: {
      "type": "range",
      "min": "0",
      "max": "1",
      "step": "0.01"
    },
    domProps: {
      "value": (_vm.opacity)
    },
    on: {
      "input": _vm.updateOpacity,
      "__r": function($event) {
        _vm.opacity = $event.target.value
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.conf.hasLegends && _vm.active && _vm.showLegend) ? [_c('context-legend', {
    attrs: {
      "conf": _vm.conf
    }
  })] : _vm._e()], 2), _vm._v(" "), (_vm.editing) ? [(_vm.conf.isGroup) ? _c('draggable', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.open),
      expression: "open"
    }],
    staticStyle: {
      "min-height": "10px"
    },
    attrs: {
      "element": "ul",
      "options": {
        group: 'items',
        draggable: '.item',
        animation: 150,
        handle: '.handle'
      }
    },
    model: {
      value: (_vm.list),
      callback: function($$v) {
        _vm.list = $$v
      },
      expression: "list"
    }
  }, _vm._l((_vm.list), function(conf) {
    return _c('item', {
      key: conf.id,
      staticClass: "item unselectable",
      attrs: {
        "conf": conf
      }
    })
  }), 1) : _vm._e()] : [(_vm.conf.isGroup) ? _c('ul', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.open),
      expression: "open"
    }],
    staticStyle: {
      "min-height": "10px"
    }
  }, _vm._l((_vm.list), function(conf) {
    return _c('item', {
      key: conf.id,
      staticClass: "item unselectable",
      attrs: {
        "conf": conf
      }
    })
  }), 1) : _vm._e()]], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-75bfa064","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Item.vue
// module id = 638
// module chunks = 2